<template>
  <app-modal
    id="modal-age-approval"
    hide-footer
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :hide-header="true"
    :modal-class="hasGermanAgeVerificationExperiment ? 'de-av-approval' : ''"
  >
    <template v-if="hasGermanAgeVerificationExperiment">
      <!-- eslint-disable vue/no-bare-strings-in-template -->
      <div class="d-flex flex-column">
        <div class="cover" />
        <div class="d-flex p-3 flex-column w-md-50">
          <h4>Sexuell explizite Inhalte</h4>
          <p class="text">Ersties ist nur für Erwachsene. Durch das Betreten bestätigst du, dass du mindestens 18 Jahre alt bist.</p>

          <div class="d-flex justify-content-evenly">
            <button class="btn btn-primary btn-outline-dark" @click="onApprove">Ich bin 18+</button>
            <button class="btn btn-outline-dark btn-exit" @click="onExit">Seite verlassen</button>
          </div>
        </div>
      </div>
      <!-- eslint-enable vue/no-bare-strings-in-template -->
    </template>
    <template v-else>
      <div class="text">
        <h4>{{ t("Verify you are over 18") }}</h4>
        <p>
          <strong>{{ t("This website contains nudity and explicit adult material.") }}</strong>
          {{
            t(
              "By entering this site you agree that you are at least 18 years old and are legally permitted to view such material in your jurisdiction.",
            )
          }}
        </p>
      </div>
      <div class="d-flex justify-content-evenly">
        <button class="btn btn-primary btn-outline-dark" @click="onApprove">
          {{ t("Enter") }}
        </button>
        <button class="btn btn-outline-dark btn-exit" @click="onExit">
          {{ t("Exit") }}
        </button>
      </div>
    </template>
  </app-modal>
</template>

<script setup lang="ts">
import { useModalStore } from "@/store/modal";
import AppModal from "@/components/v2/modals/modal";
import { setCookie } from "@/utils/cookies";
import { APPROVED_AGE_COOKIE, FEATURE_AGE_VERIFICATION } from "@/utils/variables";
import { useI18n } from "vue-i18n";
import { computed, onMounted } from "vue";
import { useFeatureStore } from "@/store/feature.ts";
import { amplitudeTrack } from "@/utils/amplitude.ts";

defineOptions({
  name: "modal-age-approval",
});

const modalStore = useModalStore();
const featureStore = useFeatureStore();
const { t, locale } = useI18n();
const deAVFeature = computed(() => {
  return locale.value === "de" ? featureStore.getFeature(FEATURE_AGE_VERIFICATION, true) : null;
});

const hasGermanAgeVerificationExperiment = computed(() => {
  return deAVFeature.value?.version === "experiment_step_1_DE";
});

const trackPopupAction = async (action: string) => {
  if (!deAVFeature.value) {
    return;
  }

  await amplitudeTrack("Age Approval Popup", {
    type: deAVFeature.value.version,
    action,
  });
};

const onApprove = () => {
  setCookie(APPROVED_AGE_COOKIE, "1", 3650);
  modalStore.hideModal("modal-age-approval");

  trackPopupAction("Approve");
};

const onExit = async () => {
  await trackPopupAction("Exit");
  window.location.href = "https://google.com";
};

onMounted(() => {
  trackPopupAction("Shown");
});
</script>

<style lang="scss">
@import "./index";
</style>
